export enum MenuMobileActions {
  settings = 'settings',
  invite = 'invite',
  raise = 'raise',
  recording = 'recording',
  feedback = 'feedback'
}
